import React, { useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import css from './VerifyEmail.module.scss';
import AppDownloadLinks from '../../components/DDRComplete/AppDownloadLinks';
import { useUser } from '../../state/user';
import { useApp } from '../../state/app';

const confirmationMessage =
  'You can close this webpage and return to your Greenlight app.';
const errorStateMessage =
  'Return to the Greenlight app and tap to resend a new verification email.';

const confirmationImagePath = '../../../static/green-check-circle.svg';
const errorStateImagePath = '../../../static/warning-icon.svg';

const VerifyEmail = ({
  startLoading,
  stopLoading,
  setNextRegStep,
  emailVerification
}: any) => {
  const { emailVerificationStatus } = useUser();
  const { registrationToken } = useApp();

  type VerificationParams = {
    verificationToken: string | null;
    userId: string | null;
  };
  const getVerificationParams = (): VerificationParams => {
    const queryParams: URLSearchParams = new URLSearchParams(
      window.location.search
    );
    return {
      verificationToken: queryParams.get('token'),
      userId: queryParams.get('userId')
    };
  };

  const { verificationToken, userId } = getVerificationParams();

  useEffect(() => {
    startLoading({ isPlaid: false });

    if (!verificationToken || !userId) {
      stopLoading();
      setNextRegStep('phone');
    }

    emailVerification({
      verificationToken,
      userId
    });
  }, []);

  useEffect(() => {
    if (emailVerificationStatus) stopLoading();
  }, [emailVerificationStatus]);

  return (
    <Layout>
      <div className={css.VerifyEmailMainBox}>
        <img
          className={css.StatusImage}
          src={
            emailVerificationStatus === 'verified'
              ? confirmationImagePath
              : errorStateImagePath
          }
        />
        {emailVerificationStatus === 'verified' ? (
          <h1 className={css.StatusHeaderSuccess}>
            {'Your email is verified!'}
          </h1>
        ) : (
          <h1 className={css.StatusHeaderFailure}>
            {'Oops! There was a problem verifying.'}
          </h1>
        )}
        <div>
          <p className={css.ResultMessage}>
            {emailVerificationStatus === 'verified'
              ? confirmationMessage
              : errorStateMessage}
          </p>
          <AppDownloadLinks promoId="" partner="" />
        </div>
      </div>
    </Layout>
  );
};

export default VerifyEmail;
